import { Pipe, PipeTransform } from '@angular/core'
import { HelperService } from '../services/helper.service'

@Pipe({
    name: 'niceDate',
    standalone: false
})
export class NiceDatePipe implements PipeTransform {
  transform(date: string, separator: string = '-', onlyDate: boolean = false): string {
    return HelperService.niceDate(date, separator, onlyDate)
  }
}
